module.exports = __webpack_public_path__ + "static/media/EdSider_Quick Guide (Student)_062024_V2.648098f2.pdf";